'use strict';
angular.module('uploadPicForWbModule', []).controller('uploadPicForWbCtrl', [
    '$scope',
    '$q',
    'Upload',
    '$modalInstance',
    '$timeout',
    'trsHttpService',
    'options',
    'modalDialog',
    'getFileMD5Service',
    function($scope, $q, Upload, $modalInstance, $timeout, trsHttpService, options, modalDialog, getFileMD5Service) {
        initStatus();
        initData();
        let time;

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}
         *   [return description]
         */
        function initStatus() {
            $scope.status = {
                pics: (options.list.PICTURE === '' || options.list.PICTURE === undefined ? [] : options.list.PICTURE.split(',')).map(
                    (item, index) => ({
                        imgName: item,
                        imgSrc: '/wcm/app/scm/file/read_image.jsp?FileName=' + item,
                    })
                ),
                dragStartIndex: 0,
            };
            console.log($scope.status.pics);
            $scope.page = {
                ITEMCOUNT: '0',
                CURRPAGE: '1',
                PAGESIZE: '20',
                PAGECOUNT: '1',
            };
            $scope.data = {
                navs: [
                    {
                        name: '本地图片',
                        value: '1',
                    },
                ],
            };
            $scope.data.selectedNav = $scope.data.navs[0].value;
        }

        /**
         * [selectFile description] 选择文件
         * @param  {[type]} $files    [description]
         * @param  {[type]} $file     [description]
         * @param  {[type]} $newFiles [description]
         * @return {[type]}           [description]
         */
        $scope.selectFile = function($files, $file, $newFiles) {
            let residualLength = 9 - $scope.status.pics.length;
            if ($newFiles.length > residualLength) {
                $newFiles.splice(residualLength, $newFiles.length);
            }
            time = 0;
            $scope.status.canClose = false;
            for (let i in $newFiles) {
                let file = $newFiles[i];
                getFileMD5Service.getMd5(file).then(function(md5) {
                    uploadPic(file, $newFiles, md5, function() {
                        $scope.status.canClose = true;
                    });
                });
            }
        };

        /**
         * [delete description] 删除选中图片
         * @return {[type]} [description]
         */
        $scope.delete = function(index) {
            $scope.status.pics.splice(index, 1);
        };

        /**
         * [uploadPic description] 上传图片
         * @return {[type]} [description]
         */
        function uploadPic(file, $newFiles, md5, finish) {
            let file_ = {};
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function(e) {
                let type = e.target.result.split(';')[0];
                type = type.split(':')[1];
                if (type != 'application/postscript') {
                    file_.imgSrc = e.target.result;
                }
            };
            $scope.status.pics.push(file_);
            Upload.upload({
                url: '/wcm/openapi/uploadImage?md5=' + md5,
                data: {
                    file: file,
                },
            }).then(
                function(resp) {
                    delete file_.progress;
                    if (resp.data.success) {
                        file_.imgSrc = resp.data.imgSrc.substring(resp.data.imgSrc.indexOf('/wcm'), resp.data.imgSrc.length);
                        file_.imgName = resp.data.imgName;
                    } else {
                        file_.error = resp.data.error;
                    }
                    time++;
                    if (time === $newFiles.length) {
                        finish();
                    }
                },
                function(resp) {
                    delete file_.progress;
                    if (resp.status == '413') {
                        file_.error = '文件太大，不得大于30MB!';
                    } else {
                        file_.error = '未知错误!';
                    }
                    time++;
                    if (time === $newFiles.length) {
                        finish();
                    }
                },
                function(evt) {
                    file_.progress = parseInt((evt.loaded / evt.total) * 100) + '%';
                    file_.FILEINFO = '上传中';
                }
            );
        }

        /**
         * [setPics description] 组装pic
         */
        function setPics() {
            let deffer = $q.defer();
            let pics = $scope.status.pics
                .filter((item, index) => !!item.imgName)
                .map((item, index) => item.imgName)
                .join(',');
            $timeout(function() {
                options.list.PICTURE = pics;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [dragStart description;拖拽开始]
         */
        $scope.dragStart = function(event, item, index) {
            $scope.status.dragStartIndex = index;
        };

        /**
         * [dragoverCallback description;允许拖拽]
         */
        $scope.dragoverCallback = function(event, index, external, type) {
            return true;
        };

        /**
         * [dragStdropCallbackart description;拖拽结束]
         */
        $scope.dropCallback = function(event, index, pic, external, type, allowedType) {
            if ($scope.status.dragStartIndex == index) {
                return;
            } else if ($scope.status.dragStartIndex > index) {
                $scope.status.pics.splice(index - 1, 0, pic);
                $scope.status.pics.splice($scope.status.dragStartIndex + 1, 1);
            } else {
                $scope.status.pics.splice(index - 1, 0, pic);
                $scope.status.pics.splice($scope.status.dragStartIndex, 1);
            }
        };

        /**
         * [getAutoHeight description] 居中提示文字
         * @return {[type]} [description]
         */
        $scope.getAutoHeight = function() {
            $timeout(function() {
                var bodyHeight = $('.publicModal .body').height(),
                    fixedAreaHeight = $('.fixedArea').height();
                var contentHeight = bodyHeight - fixedAreaHeight;
                $('.uploadContent.localUpload').height(contentHeight);
            }, 500);
        };

        function initData() {
            getFileMD5Service.init();
        }

        /**
         * [finish description] 完成
         * @return {[type]} [description]
         */
        $scope.finish = function() {
            if ($scope.data.selectedNav == '1') {
                if ($scope.status.pics.length === 0) {
                    modalDialog.alertType('请选择图片', '', 'warning', false);
                    return;
                } else {
                    setPics().then(function() {
                        let result = {
                            list: options.list,
                        };
                        $modalInstance.close(result);
                    });
                }
            } else if ($scope.data.selectedNav == '2') {
                let data = $scope.data.selectLocal;
                $scope.data.uploadPictrues = {
                    file: {
                        size: data.file.size / 1024,
                        ext: data.imgName.split('.')[1],
                    },
                    src: {
                        imgName: data.imgName,
                        imgSrc: data.imgSrc,
                        imgDesc: data.orignalImg,
                    },
                };
                if (angular.isUndefined($scope.data.uploadPictrues) || $scope.data.uploadPictrues.length === 0) {
                    modalDialog.alertType('请选择图片', '', 'warning', false);
                    return;
                }

                $modalInstance.close({
                    data: $scope.data.uploadPictrues,
                    isAddPersonalMaterial: $scope.status.isAddPersonalMaterial && $scope.data.selectedNav == '2',
                });
            }
        };

        /**
         * [changeNav description] 切换标签
         * @param  {[type]} nav [description] 标签数据
         * @return {[type]}    [description]
         */
        $scope.changeNav = function(nav) {
            $scope.data.selectedNav = nav.value;
            $scope.data.keyWords = $scope.data.keywords = '';
            if (nav.value == '2') {
                $scope.getAutoHeight();
            }
        };

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        $scope.chooseLocal = function(item) {
            $scope.data.selectLocal = item;
        };
    },
]);
